// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent as firebaseLogEvent } from "firebase/analytics";
 
const firebaseConfig = {
    apiKey: import.meta.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: import.meta.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: import.meta.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};
 
let analytics = null;
 
try {
    const app = initializeApp(firebaseConfig);
    analytics = getAnalytics(app);
} catch (e) {
    // Firebase keys missing or invalid — analytics disabled for local dev
}
 
const logEvent = (analyticsInstance, eventName, params) => {
    if (!analyticsInstance) return;
    try {
        firebaseLogEvent(analyticsInstance, eventName, params);
    } catch (e) {}
};
 
export { analytics, logEvent };
